const NO_INFO_TEXT = 'No info';

export default function textWithFallback(
  text: string | null,
  fallback = NO_INFO_TEXT,
): string {
  if (text) {
    return text;
  }

  if (typeof fallback === 'string') return fallback;

  return NO_INFO_TEXT;
}
